import React, { useState, useEffect } from 'react';
import { Col, Row, Card, Button, Badge, Container, InputGroup } from '@themesberg/react-bootstrap';

const InstallButton = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsVisible(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    
    return () => { 
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstallClick = async (e) => {
    // Adding this just as a safety net in case you wrap it in a form later
    if (e) e.preventDefault(); 
    
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === 'accepted') {
      console.log('User accepted the install prompt');
    }

    setDeferredPrompt(null);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <main>
      <Container className="px-0" style={{ backgroundColor: `#ffffff` }}>
        <section className="d-flex align-items-center my-5 mt-lg-2 mb-lg-5" >
          <Container>
            <div className="d-flex justify-content-center align-items-center mt-4">
            </div>
            
            <Row className="justify-content-center form-bg-image">
              <Col lg={12}>
                <div className="mt-4">
                  {/* Replaced Form with a div, added onClick to the Button directly */}
                  <Button 
                    variant="primary" 
                    onClick={handleInstallClick} 
                    className="w-100"
                  >
                    Install App
                  </Button>
                </div>
                <div className="d-flex justify-content-center align-items-center mt-4">
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Container>
    </main>
  );
};

export default InstallButton;